export enum AppRoutes {
  ROOT = "/",
  PROFILE = "profile",
  EMPTY_PROFILE = "emptyProfile",
  REACTIONS = "reactions",
  ERROR = "unknownError",
  TASKS = "tasks",
  INTRO_FORM = "introForm",
  MATCH = "match",
  COMMUNITY = "community",
  USER = "users/:id",
  STREAK = "streak",
  COMMUNITY_BY_ID = "community/:id",
  MATCH_SECOND_VERSION = "matchSecondVersion",
  USER_RATING = "userRating",
  AUTH_ERROR = "authError",
  LIKES = "likes",
  MATHCES = "matches",
}
